import React from 'react'
import { fetchResetTokenVerification, updatePassword, setNewPassword, setConfirmedPassword } from './resetPasswordContainerActions'
import { connect } from 'react-redux'
import ResetPassword from './ResetPassword'
import Spinner from '../../common/Spinners/Spinner'
import history from '../../core/history'
import PropTypes from 'prop-types';

class ResetPasswordContainer extends React.Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    resetToken: PropTypes.string.isRequired,
    validationstate: PropTypes.object.isRequired,
    newPassword: PropTypes.string.isRequired,
    confirmedPassword: PropTypes.string.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    updatePassword: PropTypes.func.isRequired,
    newPasswordChange: PropTypes.func.isRequired,
    confirmedPasswordChange: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    fetchResetTokenVerification: PropTypes.func.isRequired
  }

  componentDidMount () {
    this.props.dispatch(this.props.fetchResetTokenVerification(this.props.resetToken))
  }

  goToLogin () {
    history.push('/administration/login')
  }

  render () {
    if (this.props.loading) {
      return <Spinner />
    }
    return (
      <ResetPassword
        validationstate={this.props.validationstate}
        newPassword={this.props.newPassword}
        confirmedPassword={this.props.confirmedPassword}
        submitting={this.props.submitting}
        submitted={this.props.submitted}
        updatePassword={() => this.props.dispatch(this.props.updatePassword(this.props.resetToken, this.props.newPassword, this.props.confirmedPassword))}
        newPasswordChange={(newPassword) => this.props.dispatch(this.props.newPasswordChange(newPassword))}
        confirmedPasswordChange={(confirmedPassword) => this.props.dispatch(this.props.confirmedPasswordChange(confirmedPassword))}
        goToLogin={this.goToLogin}
      />
    )
  }

}

const mapStateToProps = (state) => {
  return {
    validationstate: state.resetPasswordContainer.isInvalid,
    newPassword: state.resetPasswordContainer.newPassword,
    confirmedPassword: state.resetPasswordContainer.confirmedPassword,
    submitting: state.resetPasswordContainer.submitting,
    submitted: state.resetPasswordContainer.submitted,
    loading: state.resetPasswordContainer.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchResetTokenVerification: fetchResetTokenVerification,
    updatePassword: updatePassword,
    newPasswordChange: setNewPassword,
    confirmedPasswordChange: setConfirmedPassword,
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContainer)
